interface TransportBarProps {
  readonly isPlaying: boolean;
  readonly currentStep: number;
  readonly bpm: number;
  readonly loop: boolean;
  readonly masterVolume: number;
  readonly onPlay: () => void;
  readonly onStop: () => void;
  readonly onRestart: () => void;
  readonly onPanic: () => void;
  readonly onBpmChange: (bpm: number) => void;
  readonly onLoopChange: (loop: boolean) => void;
  readonly onMasterVolumeChange: (value: number) => void;
}

export function TransportBar(props: TransportBarProps): JSX.Element {
  return (
    <div className="transport-bar" role="toolbar" aria-label="Transport">
      <button type="button" onClick={props.onPlay} disabled={props.isPlaying} aria-label="Abspielen">
        ▶ Play
      </button>
      <button type="button" onClick={props.onStop} aria-label="Stopp">
        ■ Stop
      </button>
      <button type="button" onClick={props.onRestart} aria-label="Neu starten">
        ⟲ Restart
      </button>
      <button type="button" onClick={props.onPanic} className="danger" aria-label="Panik: alle Stimmen sofort beenden">
        ⚠ Panic
      </button>

      <label className="field">
        BPM
        <input
          type="number"
          min={30}
          max={300}
          value={props.bpm}
          onChange={(event) => props.onBpmChange(Number(event.target.value))}
        />
      </label>

      <label className="field checkbox">
        <input type="checkbox" checked={props.loop} onChange={(event) => props.onLoopChange(event.target.checked)} />
        Loop
      </label>

      <label className="field">
        Master
        <input
          type="range"
          min={0}
          max={1}
          step={0.01}
          value={props.masterVolume}
          onChange={(event) => props.onMasterVolumeChange(Number(event.target.value))}
          aria-label="Gesamtlautstaerke"
        />
      </label>

      <span className="step-indicator" aria-live="polite">
        Step {props.currentStep + 1}
      </span>
    </div>
  );
}
